import React, { Fragment, forwardRef, useContext } from "react";
import { Grid, Typography, Breadcrumbs, Link } from "@material-ui/core";
import {
  AddBox,
  ArrowDownward,
  Check,
  ChevronLeft,
  ChevronRight,
  Clear,
  DeleteOutline,
  Edit,
  FirstPage,
  LastPage,
  FilterList,
  Remove,
  SaveAlt,
  Search,
  ViewColumn,
} from "@material-ui/icons";

import ReportContext from "../../../context/reports/ReportContext";

import ReportActions from "./ReportActions";
import ReportSummaryAureas from "./Aureas/ReportSummary";
// import ReportMediaBuyerAureas from "./Aureas/ReportMediaBuyer";
import ReportDetailsAureas from "./Aureas/ReportDetails";

// import ReportSummaryAlvin from "./Alvin/ReportSummary";
// import ReportDetailsAlvin from "./Alvin/ReportDetails";

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => (
    <ArrowDownward
      {...props}
      ref={ref}
      style={{
        color: "white",
      }}
    />
  )),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

const Report = () => {
  const numberFormatter = new Intl.NumberFormat("en-US");
  const currencyFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  });

  const { owner } = useContext(ReportContext);

  return (
    <Grid container spacing={1}>
      {/* Breadcrumbs */}
      <Grid container spacing={0} justifyContent="flex-start">
        <Grid item xs={12}>
          <Typography variant="h4"> Report </Typography>
        </Grid>
        <Grid item xs={12}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link color="inherit"> Report </Link>
          </Breadcrumbs>
        </Grid>
      </Grid>
      <ReportActions />
      <Grid item xs={12} container direction="column">
        {owner === "Aureas" && (
          <Fragment>
            <ReportSummaryAureas
              tableIcons={tableIcons}
              numberFormatter={numberFormatter}
              currencyFormatter={currencyFormatter}
            />
            {/* <ReportMediaBuyerAureas
              tableIcons={tableIcons}
              currencyFormatter={currencyFormatter}
            /> */}
            <ReportDetailsAureas
              tableIcons={tableIcons}
              numberFormatter={numberFormatter}
              currencyFormatter={currencyFormatter}
            />
          </Fragment>
        )}
        {owner === "Alvin" && (
          <Fragment>
            {/* <ReportSummaryAlvin
              // tableIcons={tableIcons}
              numberFormatter={numberFormatter}
              currencyFormatter={currencyFormatter}
            /> */}
            {/* <ReportDetailsAlvin
              tableIcons={tableIcons}
              numberFormatter={numberFormatter}
              currencyFormatter={currencyFormatter}
            /> */}
          </Fragment>
        )}
      </Grid>
    </Grid>
  );
};

export default Report;
